var FILE_BUTTONS={alignment:"FILE.alignment",size:"FILE.size"};export{FILE_BUTTONS};
//# sourceMappingURL=consts.js.map
